import { Form } from 'antd';
import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { findMake } from '../policies/catalogue-options';
import { useTruckCatalogue } from './use-truck-catalogue';

/** State for the make and model pickers: the catalogue, what is chosen, whether this user may extend it, and the adds with their toasts. */
export function useTruckMakeModelFields() {
  const form = Form.useFormInstance();
  const make = Form.useWatch<string | undefined>('make', form);
  const model = Form.useWatch<string | undefined>('model', form);
  const { state: catalogue, addMake, addModel } = useTruckCatalogue();
  const { state: currentUser } = useCurrentUser();
  const toast = useToast();

  const canExtend = currentUser.status === 'authenticated' && currentUser.user.permissions.includes('configuration.manage');
  const makeId = catalogue.status === 'loaded' ? findMake(catalogue.makes, make)?.id : undefined;

  return {
    catalogue,
    make,
    model,
    makeId,
    canExtend,
    /** A model belongs to one make, so changing the make drops the model. */
    changeMake: (picked: string) => {
      if (picked !== make) form.setFieldValue('model', undefined);
    },
    addMake: async (name: string) => {
      const added = await addMake(name);
      toast.success(`Make ${added} added`);
      return added;
    },
    addModel: async (name: string) => {
      const added = await addModel(makeId as string, name);
      toast.success(`Model ${added} added`);
      return added;
    },
  };
}
